import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";

const Dashboard = () => {
  const { loader, user } = useSelector((state) => state.auth);

  if (loader) return <Loader />;
  return (
    <div className="relative">
      <div className="p-4 pt-16 ">
        <div className="welcome-msg w-full">
          <p className="text-qblack text-lg">Hello, {user?.username}</p>
          <h2 className="font-bold text-[24px]">Welcome to your Profile</h2>
        </div>
        <div className="p-4 border-1 border-gray-200 border-1 dark:border-gray-700">
          <div className="grid grid-cols-3 gap-4 mb-4">
            <li>Total Products: 20</li>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
